import { ScrollView, StyleSheet, Text, View } from 'react-native';
import { theme } from '@/constants/theme';

export default function Carousel({ items }: { items: { quote: string; by: string }[] }) {
  return (
    <ScrollView horizontal showsHorizontalScrollIndicator={false} contentContainerStyle={s.row}>
      {items.map((item, i) => (
        <View key={i} style={s.card}>
          <Text style={s.quote}>{item.quote}</Text>
          <Text style={s.by}>{item.by}</Text>
        </View>
      ))}
    </ScrollView>
  );
}

const s = StyleSheet.create({
  row: { gap: 12, paddingVertical: 4, paddingHorizontal: 2 },
  card: { width: 280, backgroundColor: '#13172A', borderRadius: 16, borderWidth: 1, borderColor: '#2A315A', padding: 14 },
  quote: { color: '#E4E8FF', fontFamily: theme.fonts.medium, fontSize: 14, textAlign: 'right' },
  by: { color: '#8A94C9', fontFamily: theme.fonts.regular, fontSize: 12, textAlign: 'right', marginTop: 10 },
});
